const STORAGE_KEY = 'shopx-distribution.tenantUrl';

/**
 * Resolves the Kadanza host origin from the iframe URL.
 *
 * With path-based routing, in-app navigation drops query params, so the initial
 * `tenantUrl` is persisted for the session — without it the postMessage target
 * origin would be lost after the first navigation and token refresh would stop
 * working.
 */
export function resolveTenantUrlParam(): string | null {
  if (typeof window === 'undefined') return null;

  const fromUrl = new URLSearchParams(window.location.search).get('tenantUrl');
  if (fromUrl) {
    sessionStorage.setItem(STORAGE_KEY, fromUrl);
    return fromUrl;
  }
  return sessionStorage.getItem(STORAGE_KEY);
}
